import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import dayjs from 'dayjs';

import { useGetConferenceDetailApi } from '@/api/conference';
import infoBanner from '@/assets/img/banner/information.jpg';
import shareIcon from '@/assets/img/icon/shareIcon.svg';
import SubBanner from '@/components/common/Banner/SubBanner/SubBanner';
import ModalPortal from '@/components/common/Modal/ModalPortal/ModalPortal';
import ModalShare from '@/components/common/Modal/ModalShare/ModalShare';
import DownloadIcon from '@/components/Icon/DownloadIcon';
import LineIcon from '@/components/Icon/lineIcon';
import SingleArrowNext from '@/components/Icon/SingleArrowNext';
import SingleArrowPrev from '@/components/Icon/SingleArrowPrev';
import { SOCIETY_MENU_GUIDE } from '@/constants/society';
import { downloadFile } from '@/utils/fileUtils';

import * as S from './style';

const SocietyGuideDetail = () => {
	const { t } = useTranslation();
	const params = useParams();
	const navigate = useNavigate();
	const { id } = params;
	const [isOpenShare, setIsOpenShare] = useState(false);

	const { data: conferenceDetailData, refetch: refetchConferenceDetail } = useGetConferenceDetailApi({
		guide_pk: id ?? '',
	});

	useEffect(() => {
		if (id) {
			refetchConferenceDetail();
		}
	}, [id, refetchConferenceDetail]);

	const handleOpenModalShare = (bool: boolean) => {
		setIsOpenShare(bool);
	};

	const formatBytesToKB = (bytes: number) => `${Math.round(bytes / 1024)} KB`;

	return (
		<>
			<main>
				<SubBanner variant="compact" subTitle="society.guideDetail.subtitle" title="society.guideDetail.title" img={infoBanner} />
				<S.ConferenceContainer>
					<S.ConferenceHeader>
						<S.ConferenceTitleBox>
							<S.ConferenceTitle>{conferenceDetailData?.conferences.guide_title ?? ''}</S.ConferenceTitle>
							<S.ConferenceSubTitle>
								{dayjs(conferenceDetailData?.conferences.guide_enrollment_date).format('YYYY-MM-DD') ?? ''}
								<LineIcon />
								{t('society.guideDetail.views')} {conferenceDetailData?.conferences.guide_hit ?? '0'}
								<LineIcon />
								{t('society.guideDetail.author')} {conferenceDetailData?.conferences.admin_name}
							</S.ConferenceSubTitle>
						</S.ConferenceTitleBox>
						<div className="share_icon">
							<S.ImgBox onClick={() => setIsOpenShare(!isOpenShare)}>
								<img src={shareIcon} alt={t('society.guideDetail.shareAlt')} />
							</S.ImgBox>
						</div>
					</S.ConferenceHeader>
					<S.ContentBox>
						<S.Content dangerouslySetInnerHTML={{ __html: conferenceDetailData?.conferences.guide_content ?? '' }} />
						<S.DownLoadBoxList>
							{conferenceDetailData?.conferences.file?.map((item, index) => (
								<S.DownLoadBox key={index} onClick={() => downloadFile(item.file_path ?? '', item.file_pk?.toString() ?? '')}>
									<S.DownLoadContent>
										<div className="title">{item.file_original_name ?? ''}</div>
										<div className="sub_title">{formatBytesToKB(item.file_size ?? 0)}</div>
									</S.DownLoadContent>
									<DownloadIcon iconColor="#ADB5BD" width="20" height="20" />
								</S.DownLoadBox>
							))}
						</S.DownLoadBoxList>
						<S.MenuBox>
							<S.MenuList>
								{!conferenceDetailData?.prev_pk ? (
									<></>
								) : (
									<S.Menu type="button" onClick={() => navigate(`/society/guide/${conferenceDetailData?.prev_pk}`)}>
										<SingleArrowPrev iconColor="#212529" width="18" height="18" /> {t('society.guideDetail.prev')}
									</S.Menu>
								)}
								{!conferenceDetailData?.next_pk ? (
									<></>
								) : (
									<S.Menu type="button" onClick={() => navigate(`/society/guide/${conferenceDetailData?.next_pk}`)}>
										{t('society.guideDetail.next')}
										<SingleArrowNext iconColor="#212529" width="18" height="18" />
									</S.Menu>
								)}
							</S.MenuList>
							<S.MenuList>
								<S.MenuActive type="button" onClick={() => navigate('/society', { state: { menu: SOCIETY_MENU_GUIDE } })}>
									{t('society.guideDetail.list')}
								</S.MenuActive>
							</S.MenuList>
						</S.MenuBox>
					</S.ContentBox>
				</S.ConferenceContainer>
			</main>
			{isOpenShare && (
				<ModalPortal>
					<ModalShare onClick={handleOpenModalShare} />
				</ModalPortal>
			)}
		</>
	);
};

export default SocietyGuideDetail;
